import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container, Form,  Divider, Button } from 'semantic-ui-react';
import { DateInput } from 'semantic-ui-calendar-react';
import useReadUser from '../../Hooks/Users/useReadUser';
import useReadOneToOne from '../../Hooks/Users/OneToOne/useReadOneToOne';
import useUpdateOneToOne from '../../Hooks/Users/OneToOne/useUpdateOneToOne';
import { MessageContext } from '../../Context/MessageContext';

const EditUser = (props) => {

    const { t } = useTranslation();
    const { addMessage, removeMessage, messages } = useContext(MessageContext);
    const { userId, oneToOneId } = useParams();
    const { user, readUser } = useReadUser();
    const { oneToOne, readOneToOne } = useReadOneToOne();
    const { updateOneToOne } = useUpdateOneToOne();

    const [ date, setDate ] = useState(null);
    const [ description, setDescription ] = useState('');

    useEffect(() => {
        (async() => {
            await readOneToOne(userId,oneToOneId);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        (async() => {
            await readUser(userId);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Set user data
    useEffect(() => {
        (async () => {
            if (oneToOne.data && oneToOne.data.Id) {
                setDate(oneToOne.data.Date ? new Date(oneToOne.data.Date).toLocaleDateString() : '');
                setDescription(oneToOne.data.Description || '');
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [oneToOne]);

    const handleSave = async () => {
        messages.map(msg => removeMessage(msg.id));

        //validate
        if(!date) {
            addMessage({type: "error", header: t('message.fillInRequiredInformation'), body: t('message.requiredMarkedWithAsterisk')})
            window.scrollTo(0, 0)
        } else {
            // Format date
            let dateParts = []
            let dateISO = null;
            if(date) {
                dateParts=date.split('.');
                dateISO=new Date(dateParts[2] + "-" + dateParts[1].padStart(2,"0") + "-" + dateParts[0].padStart(2,"0")).toISOString();
            }

            //create data
            let data = {
                "date": dateISO,
                "description": description
            }

            //save
            let result = null;
            result = await updateOneToOne(userId,oneToOneId,data);

            if(result.status === 200) {
                props.history.goBack();
            }
        }
    }

    return (
        <div className='userform'>
            <Form>
                <Container className="userlist">
                    <h1>{t('heading.user')}</h1>
                    
                    <h2>{t('heading.user')}</h2>
                    <div>{user.data && user.data.FirstName} {user.data && user.data.LastName}</div>
                
                    <h2>{t('oneToOne.date')}<sup><i className='icon asterisk'></i></sup></h2>
                    <DateInput
                        localization='fi'
                        dateFormat={'DD.MM.YYYY'}
                        value={date || ""}
                        iconPosition="right"
                        onChange={(ev, {value}) => setDate(value) }
                        closable={true}
                        popupPosition='bottom left'
                    />
                
                    <h2>{t('oneToOne.description')}</h2>
                    <Form.TextArea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </Container>
            </Form>
            <Divider/>
            <Button onClick={() => handleSave()}>{t('general.save')}</Button>
            <Button onClick={() => props.history.goBack()}>{t('general.cancel')}</Button>
        </div>
    )

}

export default EditUser;